/**
 * @fileoverview lib/index.ts - Main library exports
 *
 * This file provides a centralized export point for all library functionality.
 * It allows for cleaner imports throughout the application while maintaining
 * clear separation between different API implementations.
 */

// Core API functionality and data (selective exports to avoid conflicts)
export { COLLECTIONS, fetchWalletCollections, getUserCollections, manuallyCheckCollection, checkDataConsistency, autoSyncWalletData } from './api'
export type { NFTCollection } from './api'
export type {
  AlchemyNFT,
  AlchemyResponse,
  EtherscanNFTResponse,
  OpenSeaAsset
} from './api'

// Optimized multi-chain collection checking
export { checkCollectionsInParallelWithProgress } from './optimized-api'
export { checkCollectionsWithDelegatedWallets } from './optimized-api'

// Blockchain-specific utilities
export * from './ethereum-config'
export * from './base-chain'
export * from './ronin-chain'

// Protection and error handling
export * from './protection'

// Analytics and debugging
export * from './analytics'
export * from './debug'

// Image and metadata generation (selective exports to avoid conflicts)
export { generateTotemImage } from './totem-image-generator'
export { generateTotemMetadata } from './totem-metadata'
